var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-can-16-Light 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 7.5C6 7.22386 5.77614 7 5.5 7C5.22386 7 5 7.22386 5 7.5V11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5V7.5Z",
    fill: "#EC4C47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.5 7C7.77614 7 8 7.22386 8 7.5V11.5C8 11.7761 7.77614 12 7.5 12C7.22386 12 7 11.7761 7 11.5V7.5C7 7.22386 7.22386 7 7.5 7Z",
    fill: "#EC4C47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 7.5C10 7.22386 9.77614 7 9.5 7C9.22386 7 9 7.22386 9 7.5V11.5C9 11.7761 9.22386 12 9.5 12C9.77614 12 10 11.7761 10 11.5V7.5Z",
    fill: "#EC4C47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2.75V4H1C0.723858 4 0.5 4.22386 0.5 4.5C0.5 4.77614 0.723858 5 1 5H2.04751L2.86741 13.199C2.96965 14.2214 3.82998 15 4.85748 15H10.1425C11.17 15 12.0304 14.2214 12.1326 13.199L12.9525 5H14C14.2761 5 14.5 4.77614 14.5 4.5C14.5 4.22386 14.2761 4 14 4H11V2.75C11 1.7835 10.2165 1 9.25 1H5.75C4.7835 1 4 1.7835 4 2.75ZM5.75 2C5.33579 2 5 2.33579 5 2.75V4H10V2.75C10 2.33579 9.66421 2 9.25 2H5.75ZM11.9475 5L11.1376 13.0995C11.0864 13.6107 10.6563 14 10.1425 14H4.85748C4.34373 14 3.91356 13.6107 3.86244 13.0995L3.05249 5H11.9475Z",
    fill: "#EC4C47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/trash-can.f6ea639ae0b66df62b8cd5785d951262.svg";
export { ForwardRef as ReactComponent };